import { APPOINTMENT_ACTION } from "./index";

export const updateAppointmentDetail = (name, value) => (
  dispatch,
  getState
) => {
  if (getState().appointment[name] === value) return;
  dispatch({
    type: APPOINTMENT_ACTION.UPDATE_APPOINTMENT_DETAIL,
    payload: {
      name,
      value
    }
  });
};



// WEBPACK FOOTER //
// ./src/modules/BookingPortal/actions/appointmentDetailActions.js